/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { toast } from 'react-toastify';
import axios from 'axios';
import * as keys from '../../../services/config/Keys';

// eslint-disable-next-line import/prefer-default-export
export const useSubscribe = () => {
  const subscribeForPlanWithFlutterWave = (monthNum, plan, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const x = window.getpaidSetup({
      PBFPubKey: `${keys.FLUTTERWAVE_PUBLIC_KEY}`,
      customer_email: email,
      amount: Number(monthNum * plan.monthly_subscription),
      customer_phone: phoneNumber,
      currency: 'GHS',
      country: 'GH',
      payment_options: 'card,account',
      txref: 'rave-tizeti-ghana',
      meta: [
        {
          name: `${firstName} ${lastName}`,
          email,
          phone: phoneNumber,
        },
      ],
      onclose() {},
      callback: (response) => {
        // const txref = response.tx.txRef; // collect txRef returned and pass to a server page to complete status check.
        if (
          response.success === true &&
          response.tx.amount === Number(plan.monthly_subscription)
        ) {
          toast.success('Transaction successful');
        } else {
          toast.error('Unable to make payment');
        }

        if (
          response.tx.chargeResponseCode === '00' ||
          response.tx.chargeResponseCode === '0'
        ) {
          // redirect to a success page
        } else {
          // redirect to a failure page.
        }

        x.close(); // use this to close the modal immediately after payment.
      },
    });
  };

  const subscribeForPlanWithPaystack = (monthNum, plan, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const multipliedAmount = monthNum * plan * 100;
    const newAmount = 0.02 * multipliedAmount + multipliedAmount;
    const handler = window.PaystackPop.setup({
      key: `${keys.PAYSTACK_PK_GH_LIVE_KEY}`,
      email,
      amount: Math.round(newAmount),
      currency: 'GHS',
      ref: `TZT_GHWifi_${phoneNumber}_${Math.floor(
        Math.random() * 1000000000000000 + 1,
      )}`,
      metadata: {
        custom_fields: [
          {
            email,
            firstname: firstName,
            lastname: lastName,
            amount: newAmount,
            phoneNumber,
          },
        ],
      },
      callback(callbackResponse) {
        if (callbackResponse.status === 'success') {
          const ref = callbackResponse.reference;
          try {
            fetch(
              `https://api.tizeti.com/api/v1/paystack/verify?reference=${ref}&countryCode=gh`,
            ).then(async (response) => {
              const data = await response.json();
              if (
                data.data.status === 'success' &&
                data.data.domain === 'live'
              ) {
                toast.success('Transaction Successful!');
              }
            });
          } catch (e) {
            toast.error('Transaction Failed!');
          }
        } else {
          toast.info('Payment not successful!');
        }
      },
      onClose() {},
    });
    handler.openIframe();
  };

  const subscribeForRecurringPlanWithPaystack = (subscribePlanCode, user) => {
    const { firstName, lastName, phoneNumber, email } = user;
    const handler = window.PaystackPop.setup({
      key: `${keys.PAYSTACK_PK_GH_LIVE_KEY}`,
      email,
      currency: 'GHS',
      plan: subscribePlanCode,
      channels: ['card'],
      firstname: firstName,
      lastname: lastName,
      ref: `TZT_GHWifi_RECUR_${phoneNumber}_${Math.floor(
        Math.random() * 1000000000000000 + 1,
      )}`,
      metadata: {
        custom_fields: [
          {
            email,
            firstname: firstName,
            lastname: lastName,
            phoneNumber,
          },
        ],
      },
      callback(callbackResponse) {
        if (callbackResponse.status === 'success') {
          const ref = callbackResponse.reference;
          try {
            fetch(
              `https://api.tizeti.com/api/v1/paystack/verify?reference=${ref}&countryCode=gh`,
            ).then(async (response) => {
              const data = await response.json();
              if (
                data.data.status === 'success' &&
                data.data.domain === 'live'
              ) {
                toast.success('Transaction Successful!');
              }
            });
          } catch (e) {
            toast.error('Transaction Failed!');
          }
        } else {
          toast.info('Payment not successful!');
        }
      },
      onClose() {},
    });
    handler.openIframe();
  };

  return { subscribeForPlanWithFlutterWave, subscribeForPlanWithPaystack };
};
